import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';

import { DividerVariantEnum } from '~/component/divider/enums/divider-variant.enum';
import { VtmnPlayIconTypeEnum } from '~/component/vtmn-play-icon/enums/vtmn-play-icon-type.enum';

@Component({
  selector: 'app-organizer-shared-layout-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
})
export class OrganizerSharedLayoutListComponent {
  @Input() public readonly ariaLabel: string;
  @Input() public readonly backLink: RouterLink;
  @Input() public readonly backLinkParams = {};
  @Input() public readonly subtitle: string;
  @Input() public readonly title: string;

  public readonly dividerVariant = DividerVariantEnum;
  public readonly iconType = VtmnPlayIconTypeEnum;
}
